import script from "./RegisterCompany.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterCompany.vue?vue&type=script&setup=true&lang=js"

import "./RegisterCompany.vue?vue&type=style&index=0&id=1dc55304&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dc55304"]])

export default __exports__